import React, { createContext, useContext, useState, useEffect } from 'react';
import tr from './tr.json';
import en from './en.json';
import ar from './ar.json';

const translations = { tr, en, ar };

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('dmr-lang') || 'tr';
  });

  useEffect(() => {
    localStorage.setItem('dmr-lang', language);
    // Set RTL for Arabic
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    let value = translations[language];
    
    // First try direct lookup for flat keys with dots
    if (value && value[key] !== undefined) {
      return value[key];
    }

    // Then try nested lookup
    const keys = key.split('.');
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key; // fallback to key
      }
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
